import { defineComponent, ref, watch } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CheckboxPC",
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props, { emit }) {
    const props = __props;
    const checked = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (value) => {
        checked.value = props.disabled ? true : value;
      },
      { immediate: true }
    );
    function handleCheckBoxClick() {
      checked.value = !checked.value;
      emit("input", checked.value);
    }
    function handleValueChange(event) {
      checked.value = event.target.checked;
      emit("input", event.target.checked);
    }
    return { __sfc: true, props, checked, emit, handleCheckBoxClick, handleValueChange };
  }
});
export {
  _sfc_main as default
};
